import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-learning-courses',
  templateUrl: './learning-courses.component.html',
  styleUrls: ['./learning-courses.component.scss']
})
export class LearningCoursesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
